import React, { Component } from 'react';
import { BrowserRouter as Router, Route, Link, Switch, Redirect } from 'react-router-dom';
import i18n from "i18next";
import Login from '../Pages/Login/Login.page';
import ResetPassword from '../Pages/ResetPassword/ResetPassword.page';
import ResetVerify from '../Pages/ResetVerify/ResetVerify.page';
import CreateNewPassword from '../Pages/CreateNewPassword/CreateNewPassword.page';
import Terms from '../Pages/Terms/Terms.page';
import './Home.scss';
import Privacy from '../Pages/Privacy/Privacy.page';

interface HomeState<> {
    rootClass: "rtl-direction" | "ltr-direction"
}

interface HomeProps { }

class Home extends Component<HomeProps, HomeState> {
    constructor(props: HomeProps, context: any) {
        super(props, context);

        this.state = {
            rootClass: this.getDirectionClass()
        };
    }

    getDirectionClass = () => {
        return (i18n.language === 'ar' ? 'rtl-direction' : 'ltr-direction');
    }

    changeLang = (lang: string) => {
        i18n.changeLanguage(lang);
        this.setState({
            rootClass: this.getDirectionClass()
        });
    };

    render() {
        return (
            <Router basename={`${process.env.PUBLIC_URL}`}>
                <div className={`row root ${this.state.rootClass}`}>
                    <div className="col-lg-3 left-section"></div>
                    <div className="col-lg-6 middle-section">
                        <div className="languages">
                            <button className="btn change-language-btn" onClick={(e) => { this.changeLang('en') }}>{i18n.t("EN")}</button>
                            <button className="btn change-language-btn" onClick={(e) => { this.changeLang('ar') }}>{i18n.t("AR")}</button>
                        </div>
                        <div className="logo">
                            <img
                                src={`${process.env.PUBLIC_URL}/V Clinic blue.svg`}
                                className="logo-img"
                                alt={'logo'}
                            />
                        </div>
                        <Switch>
                            <Route exact path="/" component={Login} />
                            {/* <Route exact path="/register" component={SignUp} /> TODO */}
                            {/* <Route exact path="/register/verify" component={Verification} /> TODO */}
                            {/* <Route exact path="/restore" component={ResetPassword} />
                            <Route exact path="/restore/verify" component={ResetVerify} />
                            <Route exact path="/restore/reset" component={CreateNewPassword} />
                            <Route exact path="/terms" component={Terms} />
                            <Route exact path="/privacy" component={Privacy} /> */}
                            <Redirect to="/" />
                        </Switch>
                    </div>
                    <div className="col-lg-3 left-section"></div>
                </div>
            </Router>
        )
    }
}

export default Home;